type RequestQuery = any

async function api(input: RequestInfo, init?: RequestInit, query?: RequestQuery) {

    const url = constructUrl(input, constructQuery(query))

    const response = await fetch(
        url,
        {
            ...init,
            credentials: 'include'
        }
    )

    if (response.ok) {
        return parseResponse(response)
    }

    return parseErrors(response, url)
    
}

const constructUrl = (input: RequestInfo, query?: RequestQuery): string => {
    const { NEXT_PUBLIC_STRAPI } = process.env

    const baseUrl = `${NEXT_PUBLIC_STRAPI}/${input}`

    return (query ? `${baseUrl}?${new URLSearchParams(query)}` : baseUrl)
}

const constructQuery = (query?: RequestQuery): RequestQuery => {

    return query && query.locale ? { ...query, locale: switchLocale(query.locale)} : query

}

const switchLocale = (locale: string): string => {

    if (locale === 'cz') {
        return 'cs'
    }

    return locale

}

const parseResponse = (response: Response) => {
    return response.json()
}

const parseErrors = (response: Response, url: string) => {

    const { status, statusText } = response

    switch (status) {
        case 404: {
            return { status, statusText, url }
        }
        default: {
            throw new Error(response.statusText)
        }
    }
}

export default api